import Utils from "@teamprevent/common/utils";

import axios from "axios";

import { TaskCodeListModel, TaskCodeDetailModel, TaskCodeCreateModel, TaskCodeEditModel } from "./model";

class TaskCodeApi {

    private readonly apiUrl = "/api/taskcode";

    public async getAll(): Promise<TaskCodeListModel[]> {
        const query = Utils.getOnlyParameters();
        const response = await axios.get(`${this.apiUrl}${query}`);
        const data = response.data as TaskCodeListModel[];
        return data.map(this.parseModel);
    }

    public async detail(id: any): Promise<TaskCodeDetailModel> {
        const query = Utils.getOnlyParameters();
        const response = await axios.get(`${this.apiUrl}/${id}${query}`);
        const model = response.data as TaskCodeDetailModel;
        return this.parseModel(model);
    }

    public async save(taskCode: TaskCodeEditModel): Promise<TaskCodeDetailModel> {
        const query = Utils.getOnlyParameters();
        const response = await axios.put(`${this.apiUrl}/${taskCode.id}${query}`, taskCode);
        const model = response.data as TaskCodeDetailModel;
        return this.parseModel(model);
    }

    public async create(taskCode: TaskCodeCreateModel): Promise<TaskCodeDetailModel> {
        const query = Utils.getOnlyParameters();
        const response = await axios.post(`${this.apiUrl}${query}`, taskCode);
        const model = response.data as TaskCodeDetailModel;
        return this.parseModel(model);
    }

    public delete(id: any): Promise<void> {
        return axios.delete(`${this.apiUrl}/${id}`);
    }

    public parseModel(model: TaskCodeDetailModel): TaskCodeDetailModel {
        return {
            ...model
        };
    }
}

export default new TaskCodeApi();
